import { Pipe, PipeTransform } from "@angular/core";
import { BotStatus } from "../_types/bot.type";

@Pipe({
    standalone: true,
    name: "botStatusType",
})
export class BotStatusTypePipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case BotStatus.Active:
                return "Active";
            case BotStatus.Inactive:
                return "Paused";
            case BotStatus.Draft:
                return "Draft";
            case BotStatus.Closing:
                return "Closing";
            case BotStatus.WaitingForActivation:
                return "Waiting for activation";
            default:
                return "Unknown";
        }
    }
}
